import { useSearchParams } from 'react-router-dom';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';

interface TxHistoryTableHeaderProps {
  totalTransactions: number;
  currentSort: 'newest' | 'oldest';
}

export function TxHistoryTableHeader({
  totalTransactions,
  currentSort,
}: TxHistoryTableHeaderProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSortChange = (newSort: 'newest' | 'oldest') => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('sort', newSort);
    newSearchParams.set('page', '1'); // Reset to page 1 when sort changes
    setSearchParams(newSearchParams);
  };

  return (
    <div className="mb-6 flex items-center justify-between">
      <h2 className="text-lg font-medium">
        Transactions ({totalTransactions})
      </h2>
      <div className="flex items-center gap-2">
        {/* TODO: Add filter button and implement timestamp range filter */}
        {/* <Button variant="outline" size="sm" className="h-8 gap-1 px-2 text-xs">
          <Filter className="h-3.5 w-3.5" />
        </Button> */}
        <Select value={currentSort} onValueChange={handleSortChange}>
          <SelectTrigger className="h-8 w-[180px] text-xs">
            <SelectValue placeholder="Sort by" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="newest">Date (Newest First)</SelectItem>
            <SelectItem value="oldest">Date (Oldest First)</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
